import { render } from "./CarouselSection.vue?vue&type=template&id=9284aa06&scoped=true"
import script from "./CarouselSection.vue?vue&type=script&lang=js"
export * from "./CarouselSection.vue?vue&type=script&lang=js"

import "./CarouselSection.vue?vue&type=style&index=0&id=9284aa06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9284aa06"]])

export default __exports__